export default __webpack_public_path__ + "static/media/delete-api-app.244517bc.svg";